import type { TenderStatus } from '@/types/domain';
import { TENDER_STATUS_META } from '@/lib/status';
import { cn } from '@/lib/cn';

/** The one and only visual treatment for tender/contract status. Dot + label: never color alone. */
export function StatusBadge({ status, className }: { status: TenderStatus; className?: string }) {
  const meta = TENDER_STATUS_META[status];
  return (
    <span
      title={meta.description}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset whitespace-nowrap',
        meta.badge,
        status === 'cancelled' && 'line-through decoration-zinc-400',
        className,
      )}
    >
      <span className="size-1.5 rounded-full" style={{ backgroundColor: meta.color }} aria-hidden="true" />
      {meta.label}
    </span>
  );
}
